export default __webpack_public_path__ + "static/media/team82.7a797eb2.JPG";